import React, { createContext, useContext, FC } from 'react';
import { AffectedCrewPayload, Scalars } from '@bechtel/types';
import { noop } from 'lodash';

interface CrewChangeSubscriptionContextProps {
  crewChangeRequestId: Scalars['ID'] | null;
  setCrewChangeRequestId: React.Dispatch<React.SetStateAction<string>>;
  affectedCrewMembers: AffectedCrewPayload[];
  setAffectedCrewMembers: React.Dispatch<React.SetStateAction<AffectedCrewPayload[]>>;
}

const CrewChangeSubscriptionContextPrivate = createContext<CrewChangeSubscriptionContextProps>({
  crewChangeRequestId: '',
  setCrewChangeRequestId: noop,
  affectedCrewMembers: [],
  setAffectedCrewMembers: noop,
});

const { Provider } = CrewChangeSubscriptionContextPrivate;

export const useCrewChangeSubscriptionContext = () => {
  return useContext(CrewChangeSubscriptionContextPrivate);
};

export const CrewChangeSubscriptionContext: FC<CrewChangeSubscriptionContextProps> = ({
  children,
  ...subscriptionContextProps
}) => {
  return <Provider value={subscriptionContextProps}>{children}</Provider>;
};
